<template>
	<div class="z-img">
		<img id="changer"  src="/static/images/index2/changer.png" />
		<img id="v-yellow"  src="/static/images/index2/v-yellow.png" />
		<img id="a-yellow"  src="/static/images/index2/a-yellow.png" />
		<img id="power-factor"  src="/static/images/index2/power-factor.png" />
		<img id="power-yellow"  src="/static/images/index2/power-yellow.png" />
		<img id="quantity-yellow"  src="/static/images/index2/quantity-yellow.png" />
		<img id="pcs"  src="/static/images/index2/pcs.png" />
		<img id="ammeter"  src="/static/images/index2/ammeter.png" />
		<img id="solar"  src="/static/images/index2/solar.png" />
		<img id="battery"  src="/static/images/index2/battery.png" />
		<img id="battery1"  src="/static/images/index2/battery1.png" />
		<img id="battery2"  src="/static/images/index2/battery2.png" />
		<img id="battery3"  src="/static/images/index2/battery3.png" />
		<img id="battery4"  src="/static/images/index2/battery4.png" />
		<img id="battery5"  src="/static/images/index2/battery5.png" />
		<img id="charging-piple"  src="/static/images/index2/charging-piple.png" />
		<img id="s-red"  src="/static/images/index2/s-red.png" />
		<img id="p-red"  src="/static/images/index2/p-red.png" />
		<img id="v-red"  src="/static/images/index2/v-red.png" />
		<img id="a-red"  src="/static/images/index2/a-red.png" />
		<img id="tower"  src="/static/images/index2/tower.png" /><!-- 51*55 -->
		<img id="load"  src="/static/images/index2/load.png" /><!-- 59*56 -->
		<img id="cabinet"  src="/static/images/index2/cabinet.png" /><!-- 41*57 -->
		<img id="solar2"  src="/static/images/index2/solar2.png" /><!-- 61*50 -->
	</div>
</template>

<script>
export default {
	data() {
		return {
		};
	},
	created() {},
	mounted() {
	},
	methods: {
	}
};
</script>

<style lang="scss" scoped>
.z-img {
    img, object { max-width: 100%;}
}
</style>



// WEBPACK FOOTER //
// src/components/img.vue